import { Badge, Card } from '@lilith-arcana-os/ui';
import { motion } from 'framer-motion';

import type { DrawnCard } from '@lilith-arcana-os/domain';

interface DrawnCardsPanelProps {
  cards: DrawnCard[];
}

export function DrawnCardsPanel({ cards }: DrawnCardsPanelProps) {
  if (cards.length === 0) {
    return (
      <Card eyebrow="Deck" title="Nessuna carta estratta">
        <p className="text-sm text-[var(--la-text-muted)]">
          Il draw avviene lato plugin REST. Qui viene solo mostrato il risultato.
        </p>
      </Card>
    );
  }

  return (
    <div className="grid gap-3">
      {cards.map((card, index) => (
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 14 }}
          key={`${card.id}-${card.draw_index}`}
          transition={{ delay: index * 0.08 }}
        >
          <Card
            eyebrow={`Posizione ${card.position.index + 1}`}
            footer={
              <div className="flex items-center justify-between text-xs text-[var(--la-text-muted)]">
                <span>{card.position.name}</span>
                <Badge tone={card.orientation === 'upright' ? 'gold' : 'crimson'}>
                  {card.orientation}
                </Badge>
              </div>
            }
            title={card.name}
          >
            <p className="text-sm text-[var(--la-text-muted)]">
              {card.hermetic_title}
            </p>
          </Card>
        </motion.div>
      ))}
    </div>
  );
}
